import { Seal } from '@/store/store'

// initial state
const initState: Seal = {
  name: '个人印章'
}

// getters (state, getters, rootState, rootGetters) => {}
const getters = {
}

// actions ({ dispatch, commit, state }, payload) => {}
const actions = {

}

// mutations (state, payload) => {}
const mutations = {

}

export default {
  namespaced: true,
  state: initState,
  getters,
  actions,
  mutations
}
